
import React, {useEffect, useState} from "react";
import PropTypes from "prop-types";
import ReactCalendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import styles from "./Calendar.scss";
import moment from "moment";
export default function Calendar(props) {

    const handleOnClick = (date) => {
        if(props.onClick) {
            props.onClick(date);
        } else {
            console.log(date);
        }
    }

    return (
        <div className={styles.root}>
            <ReactCalendar
                onClickDay={handleOnClick}
                value={moment(props.selectedDate).toDate()}
            />
        </div>
    )

}

Calendar.propTypes = {
    dates: PropTypes.array,
    selectedDate: PropTypes.any,
    onClick: PropTypes.func,
}
